'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeAppsSaga = exports.makeAppsReducers = exports.resetReducerOn = exports.composeReducers = exports.getOrSelect = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _effects = require('redux-saga/effects');

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _utils = require('./utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // Helper for select from both string and function


var getOrSelect = exports.getOrSelect = function getOrSelect(obj, selector) {
  if (typeof selector === 'function') {
    return selector(obj);
  }

  return (0, _lodash2.default)(obj, selector);
};

var composeReducers = exports.composeReducers = function composeReducers() {
  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }

  return function (prevState, action) {
    return reducers.reduce(function (nextState, reducer) {
      if (typeof prevState === 'undefined') {
        // When le fukin prevState is undefined merge reducers
        // initial states... Cekka
        return _extends({}, nextState, reducer(undefined, action));
      } else {
        return reducer(nextState, action);
      }
    }, prevState);
  };
}; // Hight Order Reducer for reset a piece of state on certain actions


var resetReducerOn = exports.resetReducerOn = function resetReducerOn(pattern, reducer) {
  return function (previousState, action) {
    // Match action! Reset this piece of state
    if ((0, _utils.matchActionPattern)(action, pattern)) {
      return reducer(undefined, action);
    }

    return reducer(previousState, action);
  };
};

var makeAppsReducers = exports.makeAppsReducers = function makeAppsReducers(apps) {
  return Object.keys(apps).reduce(function (allReducers, appName) {
    var reducer = apps[appName].reducer;

    if (typeof reducer === 'undefined') {
      return allReducers;
    }

    return _extends({}, allReducers, typeof reducer === 'function' ? _defineProperty({}, appName, reducer) : reducer);
  }, {});
};

var makeAppsSaga = exports.makeAppsSaga = function makeAppsSaga(apps) {
  return (
    /*#__PURE__*/
    _regenerator2.default.mark(function _callee() {
      var appsNames, i, saga;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Young Gio Va = P
              appsNames = Object.keys(apps);
              i = 0;

            case 2:
              if (!(i < appsNames.length)) {
                _context.next = 10;
                break;
              }

              saga = apps[appsNames[i]].saga;

              if (!(typeof saga !== 'undefined')) {
                _context.next = 7;
                break;
              }

              _context.next = 7;
              return (0, _effects.fork)(saga);

            case 7:
              i++;
              _context.next = 2;
              break;

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    })
  );
};